import { getErrorDescription } from '../../../utils/mappers';
export function toError(reason) {
  var errorDescription = getErrorDescription(reason);

  if (reason && reason.status === 403 && errorDescription === 'Missing Wix session') {
    reason.status = 401;
    reason.message = 'Wix Session required';
    reason.data.message = 'Wix Session required';
  } else if (errorDescription === 'site_token') {
    reason.message = 'Site token has expired';
    reason.data.message = 'Site token has expired';
  } else if (errorDescription === 'Tokens mismatch') {
    reason.message = 'Tokens mismatch';
    reason.data.message = 'Tokens mismatch';
  }

  return Promise.reject(reason);
}